














import { Vue, Component } from "@/shared/vuepack";
import CommonTab from "@/employer/components/shared/CommonTab.vue";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: { CommonTab }
})
export default class CurrentPlan extends Vue {
  openLink () {
    // Make this link functional when Products page is created
    // this.$router.push({ name: RouteNames.Products });
  }
}
